import cloneDeep from "lodash/cloneDeep";
import { v4 as uuidv4 } from "uuid";
import ShareService from "../services/ShareService";

export const namespaced = true;

export const state = {
  displayShareModal: false,
  isShareModalPersistent: false,
  isFetchingData: false,
  backupPost: ShareService.getPost(),
  post: ShareService.getPost(),
  urlErrorMessages: [],
  isEditingPost: false
};
export const mutations = {
  CLOSE_SHARE_MODAL(state) {
    state.displayShareModal = false;
  },
  OPEN_SHARE_MODAL(state) {
    state.displayShareModal = true;
  },
  SET_IS_SHARE_MODAL_PERSITENT_TO_FALSE(state) {
    state.isShareModalPersistent = false;
  },
  SET_IS_SHARE_MODAL_PERSITENT_TO_TRUE(state) {
    state.isShareModalPersistent = true;
  },
  SET_IS_FETCHING_DATA_TO_FALSE(state) {
    state.isFetchingData = false;
  },
  SET_IS_FETCHING_DATA_TO_TRUE(state) {
    state.isFetchingData = true;
  },
  SET_POST(state, post) {
    state.post = ShareService.getPost(post);
  },
  SET_BACKUP_POST(state, post) {
    state.backupPost = ShareService.getPost(post);
  },
  SET_IS_EDITING_POST_TO_FALSE(state) {
    state.isEditingPost = false;
  },
  SET_IS_EDITING_POST_TO_TRUE(state) {
    state.isEditingPost = true;
  },
  SET_POST_TYPE(state, postType) {
    state.post.type = postType;
  },
  SET_POST_DESTINATION(state, payload) {
    state.post.destinations[payload.index].location = payload.location;
  },
  ADD_NEW_POST_DESTINATION(state) {
    state.post.addDestination();
  },
  DELETE_POST_DESTINATION(state, destinationIndex) {
    state.post.deleteDestination(destinationIndex);
  },
  SET_POST_TITLE(state, title) {
    state.post.title = title;
  },
  SET_POST_SEASON(state, season) {
    state.post.season = season;
  },
  SET_POST_CONTENT(state, content) {
    state.post.content = content;
  },
  SET_POST_URL(state, url) {
    state.post.url = url;
  },
  SET_POST_THEME(state, payload) {
    state.post[payload.theme] = payload.value;
  },
  ADD_POST_PICTURE(state, picture) {
    state.post.pictures.push(picture);
  },
  UPDATE_POST_PICTURE(state, payload) {
    let pictureToUpdate = state.post.pictures.find(
      picture => picture.localId === payload.localId
    );
    if (pictureToUpdate) {
      pictureToUpdate.id = payload.data.id;
      pictureToUpdate.small = payload.data.small;
      pictureToUpdate.medium = payload.data.medium;
    }
  },
  DELETE_POST_PICTURE(state, pictureIndex) {
    state.post.pictures.splice(pictureIndex, 1);
  },
  SET_PICTURE_CAPTION(state, payload) {
    state.post.pictures[payload.index].caption = payload.caption;
  },
  DELETE_LOCAL_POST_PICTURE(state, index) {
    state.post.pictures.splice(index, 1);
  },
  SET_URL_ERROR_MESSAGES(state, urlErrorMessages) {
    state.urlErrorMessages = urlErrorMessages;
  }
};
export const actions = {
  closeShareModal({ commit, state }) {
    commit("CLOSE_SHARE_MODAL");
    commit("SET_POST", ShareService.getPost());
    if (state.isEditingPost) return commit("SET_IS_EDITING_POST_TO_FALSE");
  },
  openShareModal({ commit }) {
    commit("OPEN_SHARE_MODAL");
  },
  openPostEditForm({ commit, state }) {
    commit("SET_BACKUP_POST", cloneDeep(state.post));
    commit("SET_IS_EDITING_POST_TO_TRUE");
  },
  cancelPostEdition({ commit, state }) {
    commit("SET_POST", cloneDeep(state.backupPost));
    commit("SET_IS_EDITING_POST_TO_FALSE");
  },
  manageSharePost({ commit }, post) {
    commit("OPEN_SHARE_MODAL");
    commit("SET_POST", cloneDeep(post));
  },
  setPostType({ commit, rootGetters }, postType) {
    switch (postType) {
      case "external_link":
        if (rootGetters.isWebsiteCreator) {
          commit("SET_POST_TYPE", postType);
        } else {
          commit("mutateAlert", "notAWebsiteCreator", { root: true });
        }
        break;
      case "youtube":
        if (rootGetters.isYoutubeCreator) {
          commit("SET_POST_TYPE", postType);
        } else {
          commit("mutateAlert", "notAYoutubeCreator", { root: true });
        }
        break;
      case "short_post":
      case "picture_post":
      case null:
        commit("SET_POST_TYPE", postType);
    }
  },
  setPostDestination({ commit }, payload) {
    commit("SET_POST_DESTINATION", payload);
  },
  addNewPostDestination({ commit }) {
    commit("ADD_NEW_POST_DESTINATION");
  },
  deletePostDestination({ commit }, destinationIndex) {
    commit("DELETE_POST_DESTINATION", destinationIndex);
  },
  setPostTitle({ commit }, title) {
    commit("SET_POST_TITLE", title);
  },
  setPostSeason({ commit }, season) {
    commit("SET_POST_SEASON", season);
  },
  setPostContent({ commit }, content) {
    commit("SET_POST_CONTENT", content);
  },
  setPostUrl({ commit }, url) {
    commit("SET_POST_URL", url);
  },
  setPostTheme({ commit }, payload) {
    commit("SET_POST_THEME", payload);
  },
  addPostPicture({ commit, state }, data) {
    const localId = uuidv4();
    let postPicture = ShareService.getPicture({
      file: data,
      localUrl: URL.createObjectURL(data),
      localId: localId
    });
    commit("ADD_POST_PICTURE", postPicture);
    const picture = state.post.pictures.find(
      picture => picture.localId == localId
    );
    ShareService.createPostPicture(data)
      .then(response => {
        commit("UPDATE_POST_PICTURE", {
          localId: localId,
          data: response.data
        });
        if (picture.caption) {
          ShareService.editPicture(picture);
        }
      })
      .catch(() => {
        if (picture) {
          commit("DELETE_LOCAL_POST_PICTURE", picture.localId);
          commit("mutateAlert", "pictureUploadError", { root: true });
        }
      });
  },
  deletePostPicture({ commit }, pictureIndex) {
    commit("DELETE_POST_PICTURE", pictureIndex);
  },
  setPictureCaption({ commit, state }, payload) {
    if (payload.blur && state.post.pictures[payload.index].id) {
      ShareService.editPicture(state.post.pictures[payload.index]);
    }
    if (!payload.blur) {
      commit("SET_PICTURE_CAPTION", payload);
    }
  },
  createPost({ commit, state }) {
    commit("SET_IS_SHARE_MODAL_PERSITENT_TO_TRUE");
    commit("SET_IS_FETCHING_DATA_TO_TRUE");

    ShareService.createPost(state.post)
      .then(response => {
        commit("SET_POST", response.data);
        commit("mutateAlert", "postCreated", { root: true });
      })
      .catch(error => {
        commit("SET_URL_ERROR_MESSAGES", error.response.data.detail);
      })
      .finally(() => {
        commit("SET_IS_FETCHING_DATA_TO_FALSE");
        commit("SET_IS_SHARE_MODAL_PERSITENT_TO_FALSE");
      });
  },
  publishPost({ commit }) {
    commit("SET_IS_SHARE_MODAL_PERSITENT_TO_TRUE");
    commit("SET_IS_FETCHING_DATA_TO_TRUE");
    ShareService.publishPost(state.post.nameId)
      .then(() => {
        commit("SET_POST", {});
        commit("INCREMENT_SHARE_STATE_KEY", null, { root: true });
        commit("mutateAlert", "postConfirmed", { root: true });
        // add validation alert
        commit("CLOSE_SHARE_MODAL");
      })
      .finally(() => {
        commit("SET_IS_FETCHING_DATA_TO_FALSE");
        commit("SET_IS_SHARE_MODAL_PERSITENT_TO_FALSE");
      });
  },
  editPost({ commit, state }) {
    commit("SET_IS_FETCHING_DATA_TO_TRUE");
    commit("SET_IS_SHARE_MODAL_PERSITENT_TO_TRUE");
    ShareService.editPost(state.post)
      .then(response => {
        commit("SET_POST", response.data);
        commit("INCREMENT_SHARE_STATE_KEY", null, { root: true });
        commit("mutateAlert", "postEdited", { root: true });
      })
      .finally(() => {
        commit("SET_IS_FETCHING_DATA_TO_FALSE");
        commit("SET_IS_EDITING_POST_TO_FALSE");
        commit("SET_IS_SHARE_MODAL_PERSITENT_TO_FALSE");
      });
  },
  deletePost({ commit, state }) {
    commit("SET_IS_FETCHING_DATA_TO_TRUE");
    commit("SET_IS_SHARE_MODAL_PERSITENT_TO_TRUE");
    ShareService.deletePost(state.post.nameId)
      .then(() => {
        commit("SET_POST", ShareService.getPost());
        commit("INCREMENT_SHARE_STATE_KEY", null, { root: true });
        commit("mutateAlert", "postArchived", { root: true });
        commit("CLOSE_SHARE_MODAL");
        // add validation alert
      })
      .finally(() => {
        commit("SET_IS_FETCHING_DATA_TO_FALSE");
        commit("SET_IS_SHARE_MODAL_PERSITENT_TO_FALSE");
      });
  },
  setUrlErrorMessages({ commit }, urlErrorMessages) {
    commit("SET_URL_ERROR_MESSAGES", urlErrorMessages);
  }
};
export const getters = {
  postType: state => state.post.type
};
